import { useEffect, useState } from 'react'
import {
  faNode,
  faCss3,
  faGitAlt,
  faHtml5,
  faJsSquare,
  faReact,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I'm very ambitious full stack js developer with 3 years of
            experience, looking for a role in established IT company with the
            opportunity to work with the latest technologies on challenging and
            diverse projects.
          </p>
          <br />
          <p align="LEFT">
            I'm quietly confident, naturally curious, and perpetually working on
            improving my chops one design problem at a time.
          </p>
          <br />
          <p align="LEFT">
            My engineering studies helped me a lot to start coding cause it's
            all based on logic, that's why I can say that I have a
            problem-solving attitude. <br />
            So as a Full Stack developer I am able to add on new needed skills
            and knowledge very quickly.
          </p>
          <br />
          <p>
            I hold a{' '}
            <strong style={{ fontWeight: 'bold', color: '#FFD700' }}>
              Chancenkarte visa
            </strong>
            , which means I’m already eligible to live and work in Germany and
            can relocate without the need for visa sponsorship. <br /> I’m currently
            exploring opportunities in Germany and would love to hear if your
            company or any of your clients are hiring developers like me.
          </p>
        </div>

        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faNode} color="##72A763" />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faHtml5} color="#F06529" />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
